<template>
    <a :href="href" v-bind="attrs">
        <slot></slot>
        <ArrowRightIcon class="size-4!" />
    </a>
</template>

<script setup>
import { computed } from 'vue';
import ArrowRightIcon from '../../../images/icons/arrow-right.svg';

const props = defineProps({
    color: { type: String, default: 'primary' },
    href: { type: String, default: '#' },
    external: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
});

const attrs = computed(() => {
    const values = { class: `button-${props.color}` };

    if (props.external) {
        values.target = '_blank';
        values.rel = 'noopener';
    }

    if (props.large) {
        values.class += ' button-lg';
    }

    return values;
});
</script>
